/**
 * TextUtil.js
 * 
 * Created on 31-okt-2014, 9:54:31
 *
 * @author Harm Boschloo for Ranj
 * @author Ivo Swartjes for Ranj
 **/

import { isUndefined } from "../../util/TypeUtil";

export default class TextUtil {
    /**
     * Gets font size of a createjs.Text by parsing its font style
     * @param {createjs.Text} textField 
     * @returns {number} font size
     */
    static getFontSize(textField) {
        return TextUtil.getFontSizeFromStyle(textField.font);
    }
    
    /**
     * 
     * @param {string} fontStyle CSS font string
     * @returns {number} font size
     */
    static getFontSizeFromStyle(fontStyle) {
        return parseInt(TextUtil.REGEX_NUMBER.exec(fontStyle)[1]);
    }
    
    /**
     * Replaces the font size in a CSS font string with the given new size
     * @param {number} newSize new font size
     * @param {string} fontStyle CSS font string 
     * @returns {string} the CSS font with the new given size
     */
    static replaceFontSize(newSize, fontStyle) {
        var currentFontSize = TextUtil.getFontSizeFromStyle(fontStyle);
        var newFont = fontStyle.replace(currentFontSize, newSize);
        return newFont;
    }
    
    
    /**
     * 
     * @param {createjs.Text} textField 
     * @returns {string} font name
     */
    static getFontName(textField) {
        return TextUtil.REGEX_FONT_NAME.exec(textField.font)[1];
    }
    
    /**
     * 
     * @param {createjs.Text} textField 
     * @param {number} textFieldHeight 
     */
    static centerTextVertically(textField, textFieldHeight) {
        if (isUndefined(textField.y0)) {
            textField.y0 = textField.y;
        }
        var textHeight = textField.getMeasuredHeight();
        textField.y = textField.y0 + textFieldHeight / 2 - textHeight / 2;
    }

    /**
     * 
     * @param {createjs.Text} textField 
     * @param {number} textFieldHeight 
     */
    static alignBottom(textField, textFieldHeight) {
        if (isUndefined(textField.y0)) {
            textField.y0 = textField.y;
        }
        var textHeight = textField.getMeasuredHeight();
        textField.y = textField.y0 + textFieldHeight - textHeight;
    }
}

TextUtil.REGEX_NUMBER = /^[^\d]*(\d+)/;
TextUtil.REGEX_FONT_NAME = /(?:.*px '?)([^']*)(?:'?)/i;